export enum BookingStatusFilter {
  upcoming = 'upcoming',
  requested = 'requested',
  ongoing = 'ongoing',
  completed = 'completed',
  cancelled = 'cancelled',
}
